import { Controller } from "@hotwired/stimulus"

// Invoked when a native bridge--menu item selects a share action.
export default class extends Controller {
  static values = {
    url: String,
    text: String,
    title: String
  }

  async share(event) {
    event.preventDefault()

    if (navigator.share) {
      try {
        await navigator.share({
          title: this.titleValue || undefined,
          text: this.textValue || undefined,
          url: this.urlValue || undefined
        })
      } catch (_error) {
        // User dismissed the sheet.
      }
      return
    }

    if (!this.urlValue) return

    try {
      await navigator.clipboard.writeText(this.urlValue)
    } catch {
      const textarea = document.createElement("textarea")
      textarea.value = this.urlValue
      textarea.style.position = "fixed"
      textarea.style.opacity = "0"
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand("copy")
      document.body.removeChild(textarea)
    }
  }
}
